import { PCustomerLoader, PJobLoader } from 'src/models/routedetermination';
import { postLabelV2 } from 'src/services/routedetermination';

export interface multiLabelGeneratorModel {
  pCustomerLoader?: PCustomerLoader;
  pJobLoader?: PJobLoader;
}

const PrintLabels = async (ids: string[], vigoToast: any, labelId?: string) => {
  vigoToast.loading('Generating labels');

  if (ids.length === 0) {
    vigoToast.dismiss();
    vigoToast.error('Please select at least one consignment to print labels.');

    return;
  }

  try {
    const labelResultData = await postLabelV2(ids, labelId);

    if (labelResultData.status === 200) {
      if (labelResultData.data.data?.fileBase64 === '') {
        throw new Error('Empty file string received from server.');
      }

      vigoToast.dismiss();
      vigoToast.success('Labels generated');

      const print = await import('print-js');
      print.default({ printable: labelResultData.data.data?.fileBase64, type: 'pdf', base64: true });
    } else {
      vigoToast.dismiss();
      vigoToast.error('Error generating labels');
    }
  } catch (error: any) {
    vigoToast.dismiss();
    vigoToast.error(error?.response?.data?.message ?? 'Error generating labels');
  }
};

export default PrintLabels;
